import { Basic } from "../../basic.js";
import styles from './index.css'

const template = `
    <style id="menu-styles">
        ${styles}
    </style>
    <div id="menu" class="menu">
        <div id="menu-label" class="menu-label"><slot name="label"></slot></div>
        <div id="menu-container" class="menu-container"></div>
    </div>
`;

/**
 * @class UiMenu
 * @classdesc Меню - общий компонент
 * */

export class UiMenu extends Basic {

    constructor() {
        super()
        this.opened = false
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = template;
        this.initMenu()
    }

    /**
     * Инициализация компонента меню
     * */
    initMenu() {
        this.cssElem = this.shadowRoot.getElementById("menu-styles")
        this.menu = this.shadowRoot.querySelector('#menu')
        this.menu.addEventListener('click', (e) => (this.opened = !this.opened))
    }

    /**
     * Рендер/ре-рендер меню
     * */
    render() {
        if (!this.listElem) {
            this.listElem = this.shadowRoot.querySelector('#menu-container')
            this.listElem.addEventListener('click', this.onSelect?.bind(this))
        }
        this.listElem.textContent = ''
        const activeElements = this.activeElements?.()
        if (!activeElements?.length) return
        const renderElements = activeElements.map((item) => {
            const li = document.createElement('li')
            li.setAttribute('val', item.value)
            li.innerHTML = item.label
            return li
        })
        this.listElem.append(...renderElements)
    }

    get onSelect() {
        return this._onSelect
    }
    set onSelect(v) {
        this._onSelect = v
        this.render()
    }

    get opened() {
        return this._opened;
    }
    set opened(v) {
        this._opened = v;
        const activeElements = this.activeElements?.()
        if (activeElements?.length) {
            if (this.opened) this.listElem?.classList.add('active')
            else this.listElem?.classList.remove('active')
        }
    }
}